// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--2tVYK"};